export default vm => {
    return vm.profile.customerId
        ? vm.$sreqDataProvider
            .get('permissions')
            .then(({ permissions }) => permissions)
            .catch(() => [])
        : Promise.resolve([]);
};
